import {Product} from './Product';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemTransfer} from './ContractItemTransfer';
import {ContractItemType} from './ContractItemType';
import {ContractItem} from './ContractItem';
import {ProductType} from './ProductType';

export class ProductContractItem extends ContractItem {

    product: Product;
    productId: number;
    dispatched: number;

    isWrap = false;

    type: ContractItemType = ContractItemType.group;

    constructor(p: Product = null) {
        super();

        if (p) {
            this.setProduct(p);
        }
    }

    setProduct = (p: Product): void => {

        this.product = p;
        this.productId = p.id;

        this.name = p.name;

        this.hirePrice = p.hirePrice;
        this.lossPrice = p.lossPrice;
        this.vat = p.vat;

        switch (p.type) {
            case ProductType.group:
                this.type = ContractItemType.group;
                break;
            case ProductType.product:
            case ProductType.wrap:
            default:
                this.type = ContractItemType.product;
        }
    };

}



// WEBPACK FOOTER //
// /app/src/model/Entities/ProductContractItem.ts